import { Component, OnInit,Input, EventEmitter, Output } from '@angular/core';
import { KmsService } from 'src/app/areas/kms/kms.service';
import { SwMaskService } from 'src/app/librarys/components/basic-components/sw-mask/sw-mask.service';
import { SwMassageBoxService } from 'src/app/librarys/serves/sw-massage-box.service';
declare var $,Sortable;

@Component({
  selector: 'app-rel-sort',
  templateUrl: './rel-sort.component.html',
  styleUrls: ['./rel-sort.component.css']
})
export class RelSortComponent implements OnInit {
  @Input() modelVerId:string;              // 模型版本id
  @Input() selectConcept:any;              // 选中的概念
  // 排序操作成功后向父组件发射数据
  @Output('relSave') relSave = new EventEmitter<any>();  
  // 取消操作成功后向父组件发射数据
  @Output('relCancel') relCancel = new EventEmitter<any>();  
  // 搜索概念id
  conceptId = '';
  concepts: any = [];
  relationDatas:any = [];
  sortableDatas:any = [];
  constructor(
    private kmsService: KmsService,
    private message: SwMassageBoxService,
    private swMaskService: SwMaskService
  ) { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.getDatas();
  }

  // 查询数据
  getDatas(){
    this.concepts = [];
    let params = {
      "conceptId": this.selectConcept.conceptId,
      "modelVerId": this.modelVerId,
    }
    this.kmsService.getRelationDatas(params).subscribe(
      res => {
        if (res.code == 200) {
          this.relationDatas = res.data;
          for(let i=0;i<this.relationDatas.length;i++){
            let item = this.relationDatas[i];
            if(this.selectConcept.conceptId == item.sourceConceptId){
              this.concepts.push({
                id:item.targetConceptId,
                text:item.targetConceptName
              });
              if(i == 0){
                this.conceptId = item.targetConceptId;
                // 获取关系
                this.sortableDatas = item.relationships;
                this.sortInit();
              }
            } else{
              this.concepts.push({
                id:item.sourceConceptId,
                text:item.sourceConceptName
              })
              if(i == 0){
                this.conceptId = item.targetConceptId;
                // 获取关系
                this.sortableDatas = item.relationships;
                this.sortInit();
              }
            }
          }
        } else {
          this.message.waring(res.msg);
        }
      }
    );
  }

  // 切换搜索概念名称
  searchConceptChange(event) {
    console.log(event);
    console.log(this.concepts);
    this.conceptId = event.id;
    // 获取待排序的数据
    let items = this.relationDatas.filter(item => (item.sourceConceptId == event.id && item.targetConceptId == this.selectConcept.conceptId) || (item.sourceConceptId == this.selectConcept.conceptId && item.targetConceptId == event.id));
    this.sortableDatas = items[0].relationships;
    this.sortInit();
  }


  // 排序组件初始化
  sortInit(){
    new Sortable($('#sortable')[0], {
        animation: 150,
        ghostClass: 'blue-background-class'
    });
  }

  // 表单提交方法
  onSubmit() {
    // 获取排序信息
    let sortedData = [];
    var elements = [].slice.call(document.querySelectorAll('.list-group-item'));
    elements.forEach((item,index) => {
        sortedData.push(
            {
              id: parseInt(item.id),
              sortNum: index+1,
            }
        )
    })
    this.swMaskService.openMask("数据正在保存,请稍等...");
    this.kmsService.updateRelSortNumById(sortedData).subscribe(
      result => {
        this.swMaskService.closeMask();
        if (result.code == 200) {
          this.message.success('操作成功！');
          this.relSave.emit(false);
        } else {
          this.message.waring(result.msg);
        }
      }
    )
  }

  // 取消新增或编辑操作
  cancel(){
    this.relCancel.emit(true);
  }
}
